import { FC, Suspense } from 'react'
import { useSelector } from 'react-redux'

import { OverlayLoader, PunchlistLoader } from '../components/templates'
import { authActions } from '../ducks/actions'
import { useAppDispatch } from '../ducks/hooks'
import { getConfigValue, getNewEstimateValue, isAuthorized } from '../ducks/selectors'
import { RoutesType } from './types'



const PublicRoutes: FC<RoutesType> = ({ location, children }) => {
  const dispatch = useAppDispatch()
  const userIsloggedIn = useSelector(getNewEstimateValue('userIsloggedIn'))
  const overlayLoading = useSelector(getConfigValue('overlayLoading'))
  const authorized = useSelector(isAuthorized)



  // useEffect(() => {
  //   dispatch(userActions.getUserInfo(null, (succ, userInfo) => {
  //     if (succ && userInfo && userInfo.email_verified === false) {
  //       replace('/verify-email')
  //     }
  //   }))
  // }, [])

  if (!authorized && userIsloggedIn) {
    // clean persisted estimate data when auth0 token expired
    dispatch(
      authActions.logoutRequest({
        callback: (success) => {
          // if (success) replace('/')
        },
      })
    )
  }

  return (
    <Suspense fallback={<PunchlistLoader />}>
      <OverlayLoader loading={overlayLoading}>
        {children}
      </OverlayLoader>
    </Suspense>
  )
}

export default PublicRoutes
